module.exports = __webpack_public_path__ + "static/004-ff967812f181e710e07f23e4c3a6a406.jpg";